<template>
  <div class="dtreport__sidebar__view">
    <b-sidebar
      position="absolute"
      :right="true"
      :fullheight="true"
      :overlay="false"
      :open="showSidebar"
      @close="cancelSidebar"
    >
      <div
        class="calendar-entry-form"
        v-if="showSidebar && selectedUserDriveData"
      >
        <div class="calendar-entry-sidebar-field">
          <div class="sidebar-field-header">
            {{ sidebarHeaderText }}
          </div>
        </div>

        <div class="sidebar-body">
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Tid i minutter</div>
            <b-input
              v-model="selectedUserDriveData.timeInMinutes"
              :disabled="!isAdmin"
            ></b-input>

            <div class="sidebar-field-label">Distance</div>
            <b-input
              v-model="selectedUserDriveData.distance"
              :disabled="!isAdmin"
            ></b-input>

            <div class="sidebar-field-label">Dage</div>
            <b-input
              v-model="selectedUserDriveData.days"
              :disabled="!isAdmin"
            ></b-input>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Type</div>
            <b-input
              :disabled="true"
              v-model="selectedUserDriveData.remark"
            ></b-input>
          </div>
          <!-- <select v-model="selectedUserDriveData.type">
            <option :v-for="(type, index) in types" :value="type.id">{{
              type.title
            }}</option>
          </select> -->
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label" v-if="selectedUserDriveData.type">
              Type
            </div>
            <dropdown
              v-if="selectedUserDriveData.type"
              :disabled="!isAdmin"
              :sourceList="types"
              :keyPropertyName="(o) => o.id"
              :displayPropertyName="(o) => o.title"
              :selectedValue="type"
              :backgroundColor="'white'"
              :fontSize="'1rem'"
              :padding="'7px 11px'"
              :height="'40px'"
              :dropdownWidth="'204.72px'"
              @selectionChanged="
                (type) => {
                  this.setSelectedType(type);
                }
              "
            >
            </dropdown>
          </div>
          <div
            v-if="selectedUserDriveData.createdDate"
            class="calendar-entry-sidebar-field"
          >
            <div class="sidebar-field-label">Dato</div>
            <b-datepicker
              :disabled="!isAdmin"
              v-model="selectedUserDriveData.createdDate"
              :focusedDate="selectedUserDriveData.createdDate"
              locale="da-DK"
              placeholder="Vælg en dato"
            >
            </b-datepicker>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">CHR</div>
            <b-input
              v-model="selectedUserDriveData.chr"
              :disabled="!isAdmin"
            ></b-input>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Antal ilagte emb.</div>
            <b-input
              v-model="selectedUserDriveData.totalImposed"
              :disabled="!isAdmin"
            ></b-input>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Antal FU.</div>
            <b-input
              v-model="selectedUserDriveData.totalPreliminaryInvestigations"
              :disabled="!isAdmin"
            ></b-input>
          </div>
          <!-- <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Antal FU. doner</div>
            <b-input
              v-model="
                selectedUserDriveData.totalPreliminaryInvestigationsDonor
              "
              :disabled="!isAdmin"
            ></b-input>
          </div> -->
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Forgæves besøg</div>
            <b-input
              v-model="selectedUserDriveData.vainVisits"
              :disabled="!isAdmin"
            ></b-input>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">VGProjekt</div>
            <b-checkbox
              size="is-large"
              v-model="selectedUserDriveData.vgProject"
              :disabled="!isAdmin"
            ></b-checkbox>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">På fridag</div>
            <b-checkbox
              size="is-large"
              :disabled="!isAdmin"
              v-model="selectedUserDriveData.onDayOff"
            ></b-checkbox>
          </div>
        </div>
        <div class="sidebar-footer" v-if="!isAdmin">
          <div class="sidebar-footer-controls">
            <b-button @click="cancelSidebar()" class="is-text">Luk</b-button>
          </div>
        </div>
        <div class="sidebar-footer" v-if="isAdmin">
          <div class="sidebar-footer-controls">
            <b-button @click="update()" class="is-blue" :loading="loading">{{
              sidebarHeaderText
            }}</b-button>
            <b-button @click="cancelSidebar()" class="is-text"
              >Annuller</b-button
            >
            <b-button
              v-if="selectedUserDriveData.id !== 0"
              @click="deleteItem()"
              class="is-red"
              >Slet</b-button
            >
          </div>
          <div
            class="sidebar-footer-updated content p-2 has-text-centered"
          ></div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Dropdown from "@/components/common/Dropdown.vue";
import moment, { ISO_8601 } from "moment";

export default {
  name: "dt-report-sidebar",
  components: { Dropdown },
  data: () => ({}),
  mounted() {},
  methods: {
    ...mapActions("dtReportStore", [
      "performLookup",
      "setYear",
      "setMonth",
      "cancelSidebar",
      "update",
      "setEmployeeNumber",
      "setSelectedType",
      "deleteItem",
    ]),
    formatDate(date) {
      return moment(date).format("DD/MM-YYYY");
    },
    formatTime(date) {
      return moment(date).format("hh:mm");
    },
  },
  computed: {
    ...mapGetters("dtReportStore", [
      "report",
      "employeeNumber",
      "loading",
      "year",
      "month",
      "sidebarHeaderText",
      "selectedUserDriveData",
      "showSidebar",
      "types",
    ]),
    ...mapGetters(["currentUser", "isAdmin"]),
  },
};
</script>
<style scoped>
.text-left {
  text-align: left !important;
}
.button {
  margin: 15px;
}

.is-red {
  float: right;
  margin-right: 40px;
}
.calendar-entry-sidebar-field {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
